// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../../../node_modules/less-loader/dist/cjs.js!./base/RebateSubtitleCampaign.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qiLGj3KBycfr_kmFbqL2 {
  font-size: 35px;
}
.qiLGj3KBycfr_kmFbqL2[data-variant='card'] {
  font-size: 36px;
}
.qiLGj3KBycfr_kmFbqL2[data-variant='card'] ._Sv6SnOSYVP5Fmjrc8xr {
  font-size: 18px;
}
.wQYDuXXe1SCyBf8fir_f {
}
._Sv6SnOSYVP5Fmjrc8xr {
}
.o4RwZFG3xe0reBevgC9J {
}
.T2xfn77kFc1qD3Y8rObE {
}
.TnNF_tdf2fSvR40oR45g {
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .qiLGj3KBycfr_kmFbqL2 {
    font-size: 30px;
  }
  .qiLGj3KBycfr_kmFbqL2[data-variant='card'] {
    font-size: 24px;
  }
  .qiLGj3KBycfr_kmFbqL2[data-variant='card'] ._Sv6SnOSYVP5Fmjrc8xr {
    font-size: 12px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .qiLGj3KBycfr_kmFbqL2[data-variant='card'] {
    font-size: 36px;
  }
  .qiLGj3KBycfr_kmFbqL2[data-variant='card'] ._Sv6SnOSYVP5Fmjrc8xr {
    font-size: 12px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .qiLGj3KBycfr_kmFbqL2[data-variant='card'] {
    font-size: 36px;
  }
  .qiLGj3KBycfr_kmFbqL2[data-variant='card'] ._Sv6SnOSYVP5Fmjrc8xr {
    font-size: 12px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/shared/RebateSubtitleCampaign/css/MultiViewRebateSubtitleCampaign.module.css"],"names":[],"mappings":"AAAA;EAEE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;AAEA;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;AAAA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AAAA;AAPA;AAAA;AAAA;AAAA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AAAA;AAAA;AAAA","sourcesContent":[".subtitleContainer {\n  composes: subtitleContainer from './base/RebateSubtitleCampaign.base.module.css';\n  font-size: 35px;\n}\n.subtitleContainer[data-variant='card'] {\n  font-size: 36px;\n}\n.subtitleContainer[data-variant='card'] .currency {\n  font-size: 18px;\n}\n.subtitleTextWrapper {\n  composes: subtitleTextWrapper from './base/RebateSubtitleCampaign.base.module.css';\n}\n.currency {\n  composes: currency from './base/RebateSubtitleCampaign.base.module.css';\n}\n.subtitleTextStyle {\n  composes: subtitleTextStyle from './base/RebateSubtitleCampaign.base.module.css';\n}\n.subtitleTextStyleMain {\n  composes: subtitleTextStyleMain from './base/RebateSubtitleCampaign.base.module.css';\n}\n.subtitleTextStylePrefix {\n  composes: subtitleTextStylePrefix from './base/RebateSubtitleCampaign.base.module.css';\n}\n@media (--campaign-mobile) {\n  .subtitleContainer {\n    font-size: 30px;\n  }\n  .subtitleContainer[data-variant='card'] {\n    font-size: 24px;\n  }\n  .subtitleContainer[data-variant='card'] .currency {\n    font-size: 12px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) and (--campaign-tablet-portrait-rule) {\n  .subtitleContainer[data-variant='card'] {\n    font-size: 36px;\n  }\n  .subtitleContainer[data-variant='card'] .currency {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitleContainer": `qiLGj3KBycfr_kmFbqL2 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["subtitleContainer"]}`,
	"currency": `_Sv6SnOSYVP5Fmjrc8xr ${___CSS_LOADER_ICSS_IMPORT_0___.locals["currency"]}`,
	"subtitleTextWrapper": `wQYDuXXe1SCyBf8fir_f ${___CSS_LOADER_ICSS_IMPORT_0___.locals["subtitleTextWrapper"]}`,
	"subtitleTextStyle": `o4RwZFG3xe0reBevgC9J ${___CSS_LOADER_ICSS_IMPORT_0___.locals["subtitleTextStyle"]}`,
	"subtitleTextStyleMain": `T2xfn77kFc1qD3Y8rObE ${___CSS_LOADER_ICSS_IMPORT_0___.locals["subtitleTextStyleMain"]}`,
	"subtitleTextStylePrefix": `TnNF_tdf2fSvR40oR45g ${___CSS_LOADER_ICSS_IMPORT_0___.locals["subtitleTextStylePrefix"]}`
};
export default ___CSS_LOADER_EXPORT___;
